(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioAnualService', RelatorioAnualService);

  function RelatorioAnualService($http, ngsalConfig) {

    let service = {
      exportarSimplificado: exportarSimplificado,
      exportarCompleto: exportarCompleto,
      getRegistrosFilhosBy: getRegistrosFilhosBy
    };

    return service;

    function exportarSimplificado(periodo, tipoExportacao) {
      let promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/anuario/simplificado/${periodo}`,{}, {
        responseType: 'blob',
        headers:{
          'Accept':tipoExportacao
          }
      }).then(function (response) {
        return {data: response.data, status: response.status};
      });
         
      return promise;
    }

    function exportarCompleto(parametros) {
      let promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/anuario/completo/${parametros.periodo}`, parametros, {
        responseType: 'blob',
        headers:{
          Accept:'application/pdf'
        }
      }).then(function (response) {
        return {data: response.data, status: response.status};
      });

      return promise;
    }

    function getRegistrosFilhosBy(registroAtual) {

      registroAtual = registroAtual || {};
      let promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/anuario/completo/registro/filhos`, registroAtual)
      .then(function (response) {
        return response.data;
      });

      return promise;
    }
  }

})();
